export default __webpack_public_path__ + "static/media/activeCheck.03533577.svg";